"use strict";

(function(){

var self = Fotobook.holidays.updater = {
    updateTimer: null,
    queueUpdate: function(){
        if (self.updateTimer){
            return;
        }
        self.updateTimer = setTimeout(self.update, 0);
    },
    updateOneCell: function($cell){
        var date = $cell.attr("data-date"),
            holiday,
            dateMark="",
            comment = "&nbsp;";

        if (!date){
            return;
        }
        date = new Date(date);
        holiday = Fotobook.holidays.getDate(date);

        $cell.find(".holiday-mark").remove();
        if (holiday){
            dateMark = Fotobook.holidays.renderer.drawMarkLayout(holiday);
            $cell.find(".append-date-mark").prepend(dateMark);
            comment = holiday.comment.escapeHtml();
        }
        $cell.find(".calendar-cell-title").html(comment);
    },
    update: function(){
        self.updateTimer = null;

        $(".day-inside-month").each(function(){
            self.updateOneCell($(this));
        });
    },
};

$(function(){
    $(document)
    .on(Fotobook.holidays.user.EVENT_USER_HOLIDAYS_CHANGED, function(event){
        self.queueUpdate();
    })
    ;
});

})();
